/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  /* ----------------------- Classes ---------------------- */
  class ProductPageV2 {
    constructor(sectionId) {
      this.selectors = {
        page: `.template-product.template-product--v2`,
        productSelectors: ".product__selectors",
        swatchButton: ".swatch__button",
        videoCarousel: ".accordion-video__video-wrap",
        videoCarouselSlides:
          ".accordion-video__video-wrap .accordion-video__video",
        videoCarouselVideoSlideInner: ".accordion-video__video-slide-inner",
        videoCarouselVideos: ".accordion-video__video-slide-media",
        videoPlay: ".accordion-video__video-slide-inner .icon-media-play",
        videoPause: ".accordion-video__video-slide-inner .icon-media-pause",
        imageCarousel: ".product__slides",
        imageSlides: ".product__slide",
        imageSlidesClone: ".product__slides-clone",
        thumbnailsContainer: ".thumbs-holder",
        thumbnails: ".product__thumbs--square .thumb",
        thumbLink: ".product__thumbs--square .thumb__link",
        optionValue: "[data-option-value]",
        imageMetafield: ".swatch_images",
        productJson: "[data-product-json]",
        pdpSlider: ".main-slider",
        pdpThumbnailSlider: ".thumbnail-slider",
      };

      this.dataSelectors = {
        currentVariantId: "data-current-variant-id",
        enableVariantImagesUpdate: "data-enable-variant-images-update",
      };

      this.container = $(this.selectors.page);

      // ! Don't init if no Product Page V2 Template detected
      if (!this.container.length) return;

      let productJSON = null;
      const productElemJSON = this.container.find(this.selectors.productJson);
      if (productElemJSON) {
        productJSON = productElemJSON[0].innerHTML;
      }
      if (productJSON) {
        this.productJSON = JSON.parse(productJSON);
      } else {
        console.error("Missing product JSON");
        return;
      }

      const currentVariantId = this.container.attr(
        this.dataSelectors.currentVariantId
      );
      this.enableVariantImagesUpdate = this.container.attr(
        this.dataSelectors.enableVariantImagesUpdate
      );
      this.currentVariant = this.productJSON.variants.find(
        (variant) => variant.id == currentVariantId
      );

      // Clone Image slides
      this.imageSlidesClone = $(
        this.selectors.imageSlidesClone + " " + this.selectors.imageSlides,
        this.selectors.page
      ).clone();
      $(this.selectors.imageSlidesClone, this.container).remove();

      this.init();
    }

    init() {
      this.initEventHandlers();
      this.initVideoCarousels();
      this.bindVideoEvents();
      // this.initPDPslider();
    }

    // initPDPslider() {
    //   const $pdpCarousel = $(this.selectors.pdpSlider);
    //   let flickityCarouselpdp;
    //   if ($pdpCarousel.length) {
    //     flickityCarouselpdp = new themeVendor.Flickity($pdpCarousel[0], {});
    //   }
    // }

    initEventHandlers() {
      // ! Custom hook event found in theme.js file
      $(this.selectors.page).on("theme:variant:change", (e) => {
        this.currentVariant = e.detail.variant;

        this.currentVariant.options.forEach((opt, index) => {
          let index1 = index + 1;

          $(
            this.selectors.optionValue + "[data-option-position=" + index1 + "]"
          ).html(opt);
        });

        this.handleShowCurrentVariantImagesCarousel(true);
      });

      function showSelectedVariantImages() {
        $("[data-select-position]").each(function () {
          var selectPosition = $(this);
          var optionName = selectPosition
            .find("span.radio__option-value")
            .data("option-name");
          var selectedValue = $(
            'input[name="options[' + optionName + ']"]:checked'
          ).val();

          var closestSwatchImages = selectPosition.find(
            ".swatch_images[data-swatch-position]"
          );

          $(closestSwatchImages)
            .find("img")
            .each((index, img) => {
              const $img = $(img);
              const customID = $img.data("variant-name");

              if (customID == selectedValue) {
                $img.show();
              } else {
                $img.hide();
              }
            });
        });
      }

      showSelectedVariantImages();

      $(".swatch__button").on("mouseenter", function () {
        var selectPosition = $(this).closest(".selector-wrapper");
        var selectedValue = $(this).find('input[type="radio"]').val();
        var valueName = $(this).find('input[type="radio"]').data("value-name");

        $(this)
          .closest(".selector-wrapper")
          .find(".radio__option-value")
          .html(valueName);

        var closestSwatchImages = selectPosition.find(
          ".swatch_images[data-swatch-position]"
        );

        $(closestSwatchImages)
          .find("img")
          .each((index, img) => {
            const $img = $(img);
            const customID = $img.data("variant-name");

            if (customID == selectedValue) {
              $img.show();
            } else {
              $img.hide();
            }
          });
      });

      if ($(".template-product-bundle .bundle_wrapper").length) {
        function checkActive() {
          if (
            $(".template-product-bundle .bundle_wrapper.active").length ===
            $(".template-product-bundle .bundle_wrapper").length
          ) {
            $(".template-product-bundle #atc_text").text("ADD TO CART");
            $(
              ".template-product-bundle #custom_btn .product__price"
            ).removeClass("hidden");
            $(".template-product-bundle #custom_btn").prop("disabled", false);
            $(".template-product-bundle #custom_btn").removeClass("inactive");
          } else {
            $(".template-product-bundle #custom_btn").addClass("inactive");
            setTimeout(() => {
              $(".template-product-bundle #custom_btn").prop("disabled", true);
              $(".template-product-bundle #atc_text").text(
                "SELECT YOUR SHADES"
              );
              $(
                ".template-product-bundle #custom_btn .product__price"
              ).addClass("hidden");
            }, 50);
          }
        }

        //  on click check
        $(".template-product-bundle .bundle_wrapper .swatch__button").on(
          "click",
          function () {
            var selectPosition = $(this)
              .closest(".bundle_wrapper")
              .addClass("active");
            checkActive();
          }
        );

        // Remove checked attribute on swatches on load
        $(
          ".bundle_wrapper .swatch__button [data-single-option-selector]"
        ).removeAttr("checked");
        //  on load check
        checkActive();
      }

      $(".swatch__button").on("mouseleave", function () {
        var selectPosition = $(this).closest(".selector-wrapper");
        var optionName = selectPosition
          .find("span.radio__option-value")
          .data("option-name");
        var selectedValue = $(
          'input[name="options[' + optionName + ']"]:checked'
        ).val();

        var valueName = $(
          'input[name="options[' + optionName + ']"]:checked'
        ).data("value-name");
        $(this)
          .closest(".selector-wrapper")
          .find(".radio__option-value")
          .html(valueName);

        var closestSwatchImages = selectPosition.find(
          ".swatch_images[data-swatch-position]"
        );

        $(closestSwatchImages)
          .find("img")
          .each((index, img) => {
            const $img = $(img);
            const customID = $img.data("variant-name");

            if (customID == selectedValue) {
              $img.show();
            } else {
              $img.hide();
            }
          });
      });

      // ! Custom hook event found in theme.js file - class InitSlider
      $(document).on("theme:slider:create", (e) => {
        const container = e.detail.container;
        const carouselInstance = themeVendor.Flickity.data(
          this.selectors.imageCarousel
        );

        if (
          !carouselInstance &&
          container.classList.contains("template-product--v2")
        ) {
          this.handleShowCurrentVariantImagesCarousel(true);
        }

        // On initial slider creation, force-load images in the active slides
        // using the same direct RIAS resolution used on variant change.
        if (carouselInstance) {
          setTimeout(() => {
            const carouselWidth =
              $(this.selectors.imageCarousel).width() ||
              window.innerWidth ||
              1080;
            const dpr = window.devicePixelRatio || 1;
            const targetPx = Math.round(carouselWidth * dpr);

            $(this.selectors.imageCarousel)
              .find("img[data-src]")
              .each(function () {
                const $img = $(this);
                if ($img.hasClass("lazyloaded")) return;

                const dataSrc = $img.attr("data-src") || "";
                if (!dataSrc) return;

                if (dataSrc.includes("{width}")) {
                  let widths = [360, 720, 1080, 1296, 1512, 2048];
                  try {
                    widths =
                      JSON.parse($img.attr("data-widths") || "[]") || widths;
                  } catch (e) {}
                  const best =
                    widths.find((w) => w >= targetPx) ||
                    widths[widths.length - 1];
                  $img.attr("src", dataSrc.replace("{width}", best));
                } else {
                  $img.attr("src", dataSrc);
                }

                $img.removeClass("lazyload").addClass("lazyloaded");
              });
          }, 50);
        }
      });

      $(document).on("theme:slider:destroy", (e) => {});
    }

    handleShowCurrentVariantImagesCarousel(enableScrollTo = false) {
      if (!this.enableVariantImagesUpdate) {
        return;
      }

      const self = this;

      // Filter current slides; fall back to the product media if none match this variant
      let $currentSlides = this.imageSlidesClone.clone().filter(function () {
        return $(this).data("variant-id") == self.currentVariant.id;
      });
      if (!$currentSlides.length) {
        $currentSlides = this.imageSlidesClone
          .clone()
          .filter("[data-variant-fallback]");
      }
      if (!$currentSlides.length) {
        return;
      }

      const carouselInstance = themeVendor.Flickity.data(
        this.selectors.imageCarousel
      );

      if (carouselInstance) {
        // The imageSlidesClone originals may have been partially processed by
        // lazySizes (class=lazyloading, srcset set, but NO load listeners on
        // the clone). Strip stale lazy state so the images are visible once
        // srcset is applied below.
        $currentSlides.find("img[data-product-image]").each(function () {
          $(this)
            .removeClass("lazyloading lazyloaded lazyautosizes")
            .addClass("lazyload")
            .removeAttr("srcset sizes");
        });

        // Remove all slides
        carouselInstance.remove($(this.selectors.imageSlides));
        carouselInstance.append($currentSlides);
        carouselInstance.select(0);

        setTimeout(() => {
          carouselInstance.reposition();
          carouselInstance.resize();
          carouselInstance.reloadCells();

          const carouselWidth =
            $(this.selectors.imageCarousel).width() ||
            window.innerWidth ||
            1080;
          const dpr = window.devicePixelRatio || 1;
          const targetPx = Math.round(carouselWidth * dpr);

          $(this.selectors.imageCarousel)
            .find("img[data-product-image]")
            .each(function () {
              const $img = $(this);
              if ($img.hasClass("lazyloaded")) return;

              const dataSrcset = $img.attr("data-srcset") || "";
              const dataSrc = $img.attr("data-src") || "";

              if (dataSrcset) {
                // lazySizes RIAS already generated a full srcset on the
                // original — reuse it directly on the clone.
                $img.attr("srcset", dataSrcset).attr("sizes", carouselWidth + "px");
              } else if (dataSrc.includes("{width}")) {
                // RIAS hasn't run yet — resolve {width} manually.
                let widths = [360, 720, 1080, 1296, 1512, 2048];
                try {
                  widths =
                    JSON.parse($img.attr("data-widths") || "[]") || widths;
                } catch (e) {}
                const best =
                  widths.find((w) => w >= targetPx) ||
                  widths[widths.length - 1];
                $img.attr("src", dataSrc.replace("{width}", best));
              } else if (dataSrc) {
                $img.attr("src", dataSrc);
              }

              // Transition to lazyloaded once the image actually paints.
              if ($img[0].complete && $img[0].naturalWidth > 0) {
                $img.removeClass("lazyloading lazyload").addClass("lazyloaded");
              } else {
                $img.addClass("lazyloading");
                $img.one("load", function () {
                  $img.removeClass("lazyloading lazyload").addClass("lazyloaded");
                });
              }
            });

          // Update thumbnails after cells are reloaded
          // ! DN (20240325) - Dispatched to theme.js file - class InitSlider
          document.dispatchEvent(
            new CustomEvent("theme:slider:reCreateThumbnails")
          );
        }, 200);
      }

      // On mobile, only scroll when enabled in the Form block settings
      const isMobile = window.matchMedia("(max-width: 749px)").matches;
      const mobileScrollToTop =
        $(this.selectors.page)
          .find("[data-mobile-scroll-to-top]")
          .attr("data-mobile-scroll-to-top") === "true";

      if (enableScrollTo && (!isMobile || mobileScrollToTop)) {
        window.theme.utils.scrollTo($(this.selectors.imageCarousel)[0]);
      }
    }

    initVideoCarousels() {
      const $videoCarousel = $(this.selectors.videoCarousel);
      let flickityCarousel;

      if ($videoCarousel.length) {
        flickityCarousel = new themeVendor.FlickityFade($videoCarousel[0], {
          contain: true,
          adaptiveHeight: true,
          wrapAround: true,
        });

        $(this.selectors.videoCarouselSlides).addClass(
          "accordion-video__video--loaded"
        );
        flickityCarousel.resize();
      }
    }

    bindVideoEvents() {
      const $videos = $(this.selectors.videoCarouselVideos);
      const self = this;

      $(this.selectors.videoPause).on("click", function () {
        $(this).siblings(self.selectors.videoCarouselVideos)[0].pause();
      });

      $(this.selectors.videoPlay).on("click", function () {
        $(this).siblings(self.selectors.videoCarouselVideos)[0].play();
      });

      const clearVideoState = ($elem) => {
        $($elem).removeClass(
          "accordion-video__video-slide-inner--paused accordion-video__video-slide-inner--playing"
        );
      };

      $($videos).each(function () {
        let $video = $(this);

        $video[0].onpause = function () {
          var $wrap = $(this).parents(
            self.selectors.videoCarouselVideoSlideInner
          );
          clearVideoState($wrap);
          $(this)
            .parents(self.selectors.videoCarouselVideoSlideInner)
            .addClass("accordion-video__video-slide-inner--paused");
        };

        $video[0].onplay = function () {
          var $wrap = $(this).parents(
            self.selectors.videoCarouselVideoSlideInner
          );
          clearVideoState($wrap);
          $(this)
            .parents(self.selectors.videoCarouselVideoSlideInner)
            .addClass("accordion-video__video-slide-inner--playing");
        };
      });
    }
  }

  class ProductGridItemV2 {
    constructor() {
      this.selectors = {
        productItemV2: ".product-item.product-item--v2",
        form: "[data-form-product-item-quick-add]",
        swatches: "[data-grid-swatches]",
        swatchInput: "input[data-swatch-input]",
        atcBtn: "[data-product-quick-atc]",
        newPrice: "[data-new-price]",
        compareAtPrice: "[data-compare-at-price]",
        masterSelect: ".product-select",
        quickAddHolder: ".product-quick-atc__quick-add-holder",
        errorHolder: "[data-message-error]",
        image: ".product-item__image",
        sizeSelector: "[data-grid-size-selector]",
        sizeRadio: "[data-grid-size-radio]",
      };

      this.init();
    }

    init() {
      this.handleEvents();
    }

    handleEvents() {
      const self = this;

      $(document).on(
        "change",
        this.selectors.sizeRadio,
        function () {
          const $radio = $(this);
          const $holder = $radio
            .closest(self.selectors.productItemV2)
            .find(self.selectors.quickAddHolder);

          const $select = $holder.find(self.selectors.masterSelect);
          const $label = $holder.find(".product-quick-atc-v2__label");
          const $newPrice = $holder.find(".new-price");
          const $oldPrice = $holder.find(".old-price");

          const variantId = $radio.val();
          const price = parseInt($radio.attr("data-price"), 10);
          const compareAtPrice = parseInt(
            $radio.attr("data-compare-at-price"),
            10
          );

          $select.val(variantId);
          $label.text("ADD TO CART");
          $holder.removeAttr("data-select-size-required");

          if ($newPrice.length) {
            $newPrice.html(
              themeVendor.themeCurrency.formatMoney(
                price,
                window.theme.moneyFormat
              )
            );
          }

          if ($oldPrice.length) {
            if (compareAtPrice > price) {
              $oldPrice
                .html(
                  themeVendor.themeCurrency.formatMoney(
                    compareAtPrice,
                    window.theme.moneyFormat
                  )
                )
                .removeClass("hidden");
            } else {
              $oldPrice.addClass("hidden").html("");
            }
          }
        }
      );

      $(document).on("submit", this.selectors.form, function (event) {
        event.preventDefault();

        const $holder = $(this).find(self.selectors.quickAddHolder);
        const variantId = $(this).find(self.selectors.masterSelect).val();

        const $atcButton = $(this).find(self.selectors.atcBtn);
        const $errorHolder = $(this).find(self.selectors.errorHolder);

        if ($holder.is("[data-select-size-required]") || !variantId) {
          $(this).find(self.selectors.sizeSelector).toggleClass("is-open");
          return;
        }

        const data = {
          quantity: 1,
          id: variantId,
        };
        const urlFormEncodedData = new URLSearchParams(data).toString();

        // * Refer to theme.js - Class CartDrawer - function addToCart
        window.cart.addToCart(
          urlFormEncodedData,
          null,
          $atcButton[0],
          null,
          true,
          $errorHolder[0]
        );
      });

      $(document).on(
        "mouseenter.v2",
        ".product-item--v2 [data-product-image]",
        function () {
          var $container = $(this).parents(self.selectors.productItemV2);

          var variantId = $container
            .find(self.selectors.swatches + " input:checked")
            .attr("variant-id");
          if (variantId) {
            $container
              .find(
                '.product-item__bg__under--v2[data-variant-id="' +
                  variantId +
                  '"]'
              )
              .addClass("product-item__bg__under--show");
          }
        }
      );

      $(document).on(
        "mouseleave.v2",
        ".product-item--v2 .product-link",
        function () {
          var $container = $(this).parents(self.selectors.productItemV2);

          $container
            .find(".product-item__bg__under--v2")
            .removeClass("product-item__bg__under--show");
        }
      );
    }
  }

  class FeaturedProductSizeSelector {
    constructor() {
      this.selectors = {
        form: 'form[data-select-size-required="true"]',
        optionInput: "[data-single-option-selector]",
        idInput: '[name="id"]',
        toggleButton: "[data-select-size-toggle]",
        atcText: "[data-add-to-cart-text]",
        panel: "[data-select-size-panel]",
      };

      this.init();
    }

    init() {
      this.handleEvents();
    }

    handleEvents() {
      const self = this;

      $(document).on(
        "click",
        self.selectors.form + " " + self.selectors.toggleButton,
        function (event) {
          if ($(this).attr("type") !== "button") return;

          event.preventDefault();

          $(this)
            .closest(self.selectors.form)
            .find(self.selectors.panel)
            .toggleClass("product__selectors--collapsed");
        }
      );

      $(document).on(
        "change",
        self.selectors.form + " " + self.selectors.optionInput,
        function () {
          const $form = $(this).closest(self.selectors.form);
          const $button = $form.find(self.selectors.toggleButton);
          const $text = $button.find(self.selectors.atcText);
          const variantId = $form.find(self.selectors.idInput).val();

          if (variantId) {
            $button.attr("type", "submit");
            $text.text($button.attr("data-select-size-default-label"));
          }
        }
      );
    }
  }

  class ArticlePageV2 {
    constructor() {
      this.selectors = {
        container: ".article--v2",
        articleContentImgSlider: "[data-article-slider]",
        articleContent: ".article__content",
      };

      this.dataSelectors = {
        enableFirstLetterLarge: "data-enable-first-letter-large",
      };

      this.container = $(this.selectors.container);

      // ! Don't init if no container detected
      if (!this.container.length) return;

      // Data attributes
      this.enableFirstLetterLarge =
        this.container.attr(this.dataSelectors.enableFirstLetterLarge) ===
        "true";

      this.init();
    }

    init() {
      this.initImageCarousels();
      this.addFirstLetterLargeToContent();
    }

    initImageCarousels() {
      const $imageCarousel = $(
        this.selectors.articleContent,
        this.container
      ).find(this.selectors.articleContentImgSlider);

      if ($imageCarousel.length) {
        $imageCarousel.each(function () {
          const $this = $(this);

          const carouselInstance = new themeVendor.Flickity($this[0], {
            adaptiveHeight: true,
            contain: true,
          });
          carouselInstance.resize();
        });
      }
    }

    addFirstLetterLargeToContent() {
      if (!this.enableFirstLetterLarge) return;

      const articleContent = $(this.selectors.articleContent, this.container);
      const firstPTag = articleContent.find("p:first");

      firstPTag.addClass("first-letter-large");
    }
  }

  class Sections {
    constructor() {
      this.init();
    }

    init() {
      var Flickity = themeVendor.Flickity;

      Flickity.prototype.updateFractionCounter = function () {
        var currentSlide = this.selectedIndex + 1;
        var totalSlides = this.slides.length;
        $(".swiper-pagination-current").text(currentSlide);
        $(".swiper-pagination-total").text(totalSlides);
      };

      // section-review-slider
      if ($(".review_slider").length > 0) {
        var flkty = new Flickity(".review_slider", {
          contain: false,
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          loop: true,
          on: {
            ready: function () {
              this.updateFractionCounter();
            },
            change: function () {
              this.updateFractionCounter();
            },
          },
        });

        $(".slider-component .arrow_right").on("click", function () {
          flkty.next();
        });
      }

      // section-featured-products
      let flickityInstance;

      function initializeSlider() {
        if ($(".ctm_grid_product_slider .product-grid--mobile-slider").length > 0) {
          const flickityOptions = {
            pageDots: false,
            groupCells: true,
            dragThreshold: 10,
            draggable: true,
          };

          if ($(window).width() < 749) {
            flickityOptions.contain = false;
          } else {
            flickityOptions.contain = true;
          }

          if (flickityInstance) {
            flickityInstance.destroy();
            $('.ctm_grid_product_slider .product-grid--mobile-slider .product-item').removeClass('h-full');
          }

          flickityInstance = new themeVendor.Flickity(
            ".ctm_grid_product_slider .product-grid--mobile-slider",
            flickityOptions
          );
        }
        $('.ctm_grid_product_slider .product-grid--mobile-slider .product-item').addClass('h-auto');
        if (flickityInstance) {
          setTimeout(() => {
            flickityInstance.resize();
          }, 100);
        }
      }

    initializeSlider();

    $(window).resize(function() {
      initializeSlider();
    });  
    }
  }

  /* ------------------- Document Ready ------------------- */
  $(document).ready(function () {
    // Instantiate Classes
    new ProductGridItemV2();
    new ProductPageV2();
    new FeaturedProductSizeSelector();
    new ArticlePageV2();
    new Sections();
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();